export var TAB_PLACEMENTS = {
  PAGE: 'page-level',
  CONTAINER: 'container'
};
export var DATA_ATTRS = {
  FOR: 'data-for',
  SELECTED: 'data-selected',
  TAB_PANEL: 'data-tabpanel',
  TIP: 'data-tip'
};